import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'remix';

export const ShopContentSwiper: React.VFC<{ shopImages: ShopImageDataArray }> = ({ shopImages }) => {
    return (
        <>
            <Swiper
                spaceBetween={50}
                slidesPerView={1}
                autoplay={{ delay: 2000 }}
                loop={true}
            >
                {shopImages.map((shopImage, index) => (
                    <SwiperSlide key={index}>
                        <img className='shopDetailImage' src={`/images/article/shop/${shopImage.images.image_url}`} alt={`Slide ${index + 1}`} />
                        <Link to={`https://www.instagram.com/${shopImage.images.photographer_name}`} target="_blank">
                            <div className="sliderItemUsers-container">
                                <p className="sliderItemUsers--title">撮影者</p>
                                <img className="sliderItemUsers--img" src="/icons/instagram.png" alt='撮影者画像' />
                                <p className="sliderItemUsers--text">{shopImage.images.photographer_name}</p>
                            </div>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
};
